import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';

import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/cap60-weatherization.jpeg';
import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const REPORT_DATA = [
  {
    title: '',
    items: [
      'Case Management',
      'Client Listing',
      'Case Load per Case Worker',
      'Follow-ups and Referrals',
      'Customizable Demographics',
      'Service Details & Counts',
      'Customizable Assessment Results',
      'Customized Outcome Achievement',
    ],
  },
];

const FEATURE_DATA = [
  {
    id: 1,
    title: 'Integrated Custom Workflows',
  },
  {
    id: 2,
    title: 'Required Document Listing with Upload',
  },
  {
    id: 3,
    title: 'Utilize Pre-Configured Forms and Surveys',
  },
  {
    id: 4,
    title: 'Customize Service and Funding Options',
  },
  {
    id: 5,
    title: 'Create Internal and External Referrals',
  },
  {
    id: 6,
    title: 'Unlimited Case Notes and Data Storage',
  },
];
function CaseManagement() {
  return (
    <div>
      <Helmet>
        <title>Case Management - CAP60</title>
        <meta
          name="description"
          content="With case management you can track the type and quantity of service, tracks associated funding source information, sets descriptive goals for the client. Call us Now!."
        />
        <meta name="keywords" content="case mangement, cap60 case mangement" />
      </Helmet>
      <PageBanner
        title="Case Management"
        subtitle="Record & Report Each Client Accurately"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport data={REPORT_DATA} title="Reports" />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Record & Report Each Client Accurately</h2>
          </div>
          <p>
            CAP60’s flexible case management system can support nearly program
            offered by public and private human service agencies. With CAP60’s
            intuitive workflow, users can flawlessly coordinate and deliver
            services to clients and their families. Users track service and case
            information on a simple yet comprehensive forms. Client profiles
            centralize required documents for the service, tracks the type and
            quantity of service, tracks associated funding source information,
            sets descriptive goals for the client, automates referrals,
            schedules follow-ups and automatically syncs follow-ups to the case
            worker’s calendar.
          </p>
          {/* <p>
            With CAP60’s intuitive workflow, users can flawlessly coordinate and
            deliver services to clients and their families. Users track service
            and case information on a simple yet comprehensive page called Case
            Information. This Case Information page centralizes required
            documents for the service, tracks the type and quantity of service,
            tracks associated funding source information, sets descriptive goals
            for the client, automates referrals, schedules follow-ups and
            automatically syncs follow-ups to case worker’s calendar.
          </p> */}

          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

function SampleReport({ data, title }) {
  return (
    <div className={styles.sampleReportWrapper}>
      <Container>
        <div className="heading">{!!title && <h2> {title}</h2>}</div>
        <Row>
          {data.map((rdata, idx) => (
            <Col md="6" key={idx}>
              <div className={styles.reportList}>
                <h3>{rdata.title}</h3>
                <ul>
                  {rdata.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default CaseManagement;
